const MapIcon = () => {
    return (
        <svg className={"svg-icon"} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17.25L3 18.75V5.25L9 3.75" stroke="#555755" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M15 20.25L9 17.25V3.75L15 6.75V20.25Z" stroke="#555755" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M15 6.75L21 5.25V18.75L15 20.25" stroke="#555755" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export default MapIcon